import { Deserializable } from '../../../../protocols/deserializable';
import { Address } from '../../../../users/dto/address';
import { SelfEnrolmentLogo } from '../../../../employers/self-enrolment-logo';
import { EmployerSelfEnrolmentContact } from './employer-self-enrolment-contact';

export class EmployerSelfEnrolmentSubmission implements Deserializable {
  public new!: EmployerSelfEnrolmentSubmissionData;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.new) {
      this.new = Deserialize?.instanceOf(EmployerSelfEnrolmentSubmissionData, this.new);
    }
  }
}

export class EmployerSelfEnrolmentSubmissionData implements Deserializable {
  public name!: string;
  public shortName!: string;
  public craPayrollRemittanceAccountNumber!: string;
  public headOfficeAddress!: Address;
  public mailingAddress!: Address;
  public logo!: SelfEnrolmentLogo;
  public contacts!: EmployerSelfEnrolmentContact[];

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;

    if (!!this.headOfficeAddress) {
      this.headOfficeAddress = Deserialize?.instanceOf(Address, this.headOfficeAddress);
    }

    if (!!this.mailingAddress) {
      this.mailingAddress = Deserialize?.instanceOf(Address, this.mailingAddress);
    }

    if (!!this.logo) {
      this.logo = Deserialize?.instanceOf(SelfEnrolmentLogo, this.logo);
    }

    if (!!this.contacts) {
      this.contacts = Deserialize?.arrayOf(EmployerSelfEnrolmentContact, this.contacts);
    }
  }
}
